import * as React from 'react';
import TestErrorLog from "./TestErrorLog";
import TestTrees from "./TestTrees";
import TestIndexedDb from "./TestIndexedDb";
import { isNativeApp } from '../../Dependency/NativeAppMemory';

interface TestPageState{
  tab?: string;
}

export default class TestPage extends React.Component<any, TestPageState>{
  constructor(props: any) {
    super(props);

    this.state = {
      // The app has no IndexedDB queue to look at: its stores are native
      tab: isNativeApp() ? 'trees' : 'indexeddb',
    }
  }

  changeTab(tabName: string) {
    this.setState({
      tab: tabName
    })
  }

  render() {
    const { tab } = this.state;

    return (
      <div>
        <div style={{ padding: '20px', display: "block" }}>
          {!isNativeApp() && <span style={{ display: 'inline-block' }}><a onClick={() => this.changeTab('indexeddb')}>IndexedDB</a></span>}
          <span style={{ display: 'inline-block', marginLeft: '10px' }}><a onClick={() => this.changeTab('trees')}>Trees</a></span>
          <span style={{ display: 'inline-block', marginLeft: '10px' }}><a onClick={() => this.changeTab('errors')}>Errors</a></span>
        </div>
        {tab === 'trees' && <TestTrees />}
        {tab === 'indexeddb' && !isNativeApp() && <TestIndexedDb />}
        {tab === 'errors' && <TestErrorLog />}
      </div>
    );
  }
}